import UriUtils from 'chairisher/util/uri';

const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} The various utm_* params stored in the Chairish context
 */
function getUtmParams() {
    return ChairishContext.utm || {};
}

/**
 * @returns {string|undefined} The utm_campaign param for the current page, if any
 */
export function getUtmCampaign() {
    return getUtmParams().utm_campaign;
}

/**
 * @returns {string|undefined} The utm_medium param for the current page, if any
 */
export function getUtmMedium() {
    return getUtmParams().utm_medium;
}

/**
 * @returns {string|undefined} The utm_source param for the current page, if any
 */
export function getUtmSource() {
    return getUtmParams().utm_source;
}

/**
 * Caches off the various utm_* params into the Chairish context
 */
export function storeUtmParams() {
    ChairishContext.utm = {
        utm_campaign: UriUtils.extractParamFromUri(document.location.search, 'utm_campaign'),
        utm_medium: UriUtils.extractParamFromUri(document.location.search, 'utm_medium'),
        utm_source: UriUtils.extractParamFromUri(document.location.search, 'utm_source'),
    };
}

/**
 * @returns {string} The API key to use with Amplitude
 */
export function getAmplitudeApiKey() {
    return ChairishContext.AMPLITUDE_API_KEY;
}

/**
 * @returns {string} The client-side deployment key to use with Amplitude
 */
export function getAmplitudeDeploymentKeyClient() {
    return ChairishContext.AMPLITUDE_DEPLOYMENT_KEY_CLIENT;
}

/**
 * @returns {string} The device ID from the Amplitude cookie
 */
export function getAmplitudeDeviceId() {
    return ChairishContext.AMPLITUDE_DEVICE_ID;
}

/**
 * @returns {boolean} True indicates the amplitude browser sdk 2 feature is enabled; false, if not
 */
export function isAmplitudeBrowserSDK2Enabled() {
    return !!ChairishContext.IS_AMPLITUDE_BROWSER_SDK_2_ENABLED;
}

/**
 * Purges amplitude test tags to prevent double-tagging.
 */
export function purgeAmplitudeTestTags() {
    ChairishContext.AMPLITUDE_TEST_TAGS = [];
}
